import { render, staticRenderFns } from "./ConfiguracionEvaluacion.vue?vue&type=template&id=575c4ec2&"
import script from "./ConfiguracionEvaluacion.vue?vue&type=script&lang=js&"
export * from "./ConfiguracionEvaluacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports